module.exports = __webpack_public_path__ + "img/map_all_general-group-seating.20abcce0.jpg";